export const INITIAL_VALUES = {
  preferredUserName: '',
  schoolId: null
};
